import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import 'react-toastify/dist/ReactToastify.css';
import "../src/studentassets/css/style.css";
import "../src/screenassets/css/custom.css";
import { Provider } from 'react-redux';
import store from "./service/Store";
import { BrowserRouter } from 'react-router-dom';
import "react-toastify/dist/ReactToastify.css";


/*----- Admin Dashboard ------*/
import "../src/adminassets/vendor/fonts/iconify-icons.css";
import "../src/adminassets/vendor/libs/node-waves/node-waves.css";
import "../src/adminassets/vendor/libs/pickr/pickr-themes.css";
import "../src/adminassets/vendor/css/core.css";
import "../src/adminassets/css/demo.css";
import "../src/adminassets/vendor/libs/perfect-scrollbar/perfect-scrollbar.css";
import "../src/adminassets/vendor/libs/datatables-bs5/datatables.bootstrap5.css";
import "../src/adminassets/vendor/libs/datatables-responsive-bs5/responsive.bootstrap5.css";
import "../src/adminassets/vendor/libs/apex-charts/apex-charts.css";
import "../src/adminassets/vendor/libs/swiper/swiper.css";
import "../src/adminassets/vendor/css/pages/app-ecommerce-dashboard.css";
import "../src/adminassets/vendor/libs/tagify/tagify.css";
import "../src/adminassets/vendor/libs/sweetalert2/sweetalert2.css";
import "../src/adminassets/vendor/libs/select2/select2.css";
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GoogleOAuthProvider clientId="347406036882-utp95ldledo1uq0e41v7q7ld3tvllrnd.apps.googleusercontent.com">
        <BrowserRouter>
            <Provider store={store}>
                <App />
            </Provider>
        </BrowserRouter>
    </GoogleOAuthProvider>
);

reportWebVitals();
